import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

type Props = {
  type: string;
  searchText: string;
};

const FeatureUrlSetter = ({ type, searchText }: Props) => {
  let [, setSearchParams] = useSearchParams();
  useEffect(() => {
    const params = new URLSearchParams();

    if (type) {
      params.set("type", type);
    }
    if (searchText) {
      params.set("search", searchText);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, type, searchText]);

  return <></>;
};

export default FeatureUrlSetter;
